// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ChartPieIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ChartPie/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 10a8 8 0 0 1 8-8v8h8a8 8 0 1 1-16 0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 2.252A8.014 8.014 0 0 1 17.748 8H12V2.252Z"
}));
export default ChartPieIcon;